import type { Vacancy } from '@/api/generated/types.gen';

// Fake sessions for the widget studio and /embed/<id>?sample=… (dev only). No network.
const svg = (body: string) =>
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${body}</svg>`);

export const SAMPLE_LOGOS = {
  northwind: svg(
    '<rect width="64" height="64" rx="16" fill="#0F766E"/><path d="M32 47s-14-8.4-14-18.2A7.8 7.8 0 0 1 32 24a7.8 7.8 0 0 1 14 4.8C46 38.6 32 47 32 47Z" fill="#fff"/><path d="M24 33h5l2.5-5 3 9 2.5-4H40" fill="none" stroke="#0F766E" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>',
  ),
  lumen: svg(
    '<rect width="64" height="64" rx="16" fill="#111"/><circle cx="32" cy="32" r="12" fill="none" stroke="#fff" stroke-width="5"/><circle cx="32" cy="32" r="3.5" fill="#fff"/>',
  ),
  harbor: svg(
    '<rect width="64" height="64" rx="16" fill="#1D4ED8"/><path d="M14 40c6 0 6-4 12-4s6 4 12 4 6-4 12-4M14 30c6 0 6-4 12-4s6 4 12 4 6-4 12-4" fill="none" stroke="#fff" stroke-width="4.5" stroke-linecap="round"/>',
  ),
};

function sample(
  key: string,
  name: string,
  company: string,
  options: { logo?: string; minutes?: number; video?: boolean; theme?: string } = {},
): Vacancy {
  return {
    id: `sample-${key}`,
    public_id: `sample-${key}`,
    company_id: 'sample-company',
    name,
    company_info: {
      public_id: 'sample-company',
      name: company,
      profile_image: options.logo ?? '',
      apply_page_theme: options.theme ?? null,
    },
    mind_config: {
      session_duration: options.minutes ?? 5,
      camera_required: Boolean(options.video),
    },
  } as Vacancy;
}

export const WIDGET_SAMPLES = {
  telehealth: sample('telehealth', 'New patient intake', 'Northwind Telehealth', {
    logo: SAMPLE_LOGOS.northwind,
    minutes: 4,
  }),
  careers: sample('careers', 'Front desk coordinator', 'Lumen Dental Group', {
    logo: SAMPLE_LOGOS.lumen,
    minutes: 8,
  }),
  saas: sample('saas', 'Tell us what you need', 'Harbor Analytics', {
    logo: SAMPLE_LOGOS.harbor,
    minutes: 3,
  }),
  'long-name': sample(
    'long-name',
    'Registered Nurse – Night Shift, Cardiac Step-Down Unit (Full-time, Weekend Differential)',
    'Saint Bartholomew Regional Medical Center & Outpatient Clinics',
    { minutes: 12 },
  ),
} satisfies Record<string, Vacancy>;

export type WidgetSampleKey = keyof typeof WIDGET_SAMPLES;

export function getWidgetSample(key?: string): Vacancy | undefined {
  if (!key || !(key in WIDGET_SAMPLES)) return undefined;
  return WIDGET_SAMPLES[key as WidgetSampleKey];
}
